import { registryAPI } from '@/providers/apis/registry/registry';
import { sortByProperty } from '@/utils/utils';
import { REGISTRY_TABLE_FIELDS_LIBRARY, USER_TYPE, REGISTRY_TYPE, PARTNERS_TYPE_OBJECT_ARRAY_WISE } from '@/utils/constants';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import RegistrySearchFilter from '../learner-registry/registry-search-filter/registry-search-filter';
import SubscriptionPullup from '../subcription-pullup/subscription-pullup';
import SubscribePopUp from '../partner-catalog/content-registry/subscribe-popup/subscribe-popup';
import { facetsSerializer } from '@/providers/serializers/facets/facets';

@Component({
    name: 'registry',
    props: {
        tableFields: Array,
        filterList: Array,
        showProviderDeatils: Function,
        title: String,
        onEnableAccess: Function,
        providerLogo: String,
        showHeaderDeatils: Function,
        totalLength: Number,
    },
    components: {
        'subscription-pullup': SubscriptionPullup,
        'registry-search-filter': RegistrySearchFilter,
        'subscribe-popup': SubscribePopUp,
    },
})

export default class Registry extends Vue {

    private isShowPullup: boolean = false;
    // -----------------------------------------------------------
    // Properties

    private selectedFilter: any = {};

    private providerList: any = [];

    private searchTerms: string = '';

    @Prop()
    private contentPerPgae: any;
    @Prop()
    private registryType: any;

    @Prop()
    private isLoading: any;

    @Prop()
    private userType: any;

    @Prop()
    private filterList: any;

    private currentPage: number = 1;

    private selectedRow: any;

    private isDistrictUser: boolean = false;

    private isSuperUser: boolean = false;

    private isContentProvider: boolean = false;

    private tenantId: any;

    private partnerType: any = PARTNERS_TYPE_OBJECT_ARRAY_WISE;

    private isShowSubscribePopup = false;

    private rank: any = 0;

    private useBy: any = 'route';

    private isMandatoryProduct: any = null;

    private pendingAction: any;

    // private closePullUp: any = false;

    // @Watch('closePullUp', { deep: true })
    // private onClosePullUp (value: any) {
    //     console.log('value', value);
    //     this.isShowPullup = value;
    // }

    // ---------------------------------------------------------
    // Hooks

    private created() {
        this.tenantId = this.$access.getTenantId();
        this.isDistrictUser = this.userType === USER_TYPE.districtUser;
        this.isSuperUser = this.$access.hasAllPermission;
        this.isContentProvider = this.userType === USER_TYPE.contentProvider;
    }


    // ------------------------------------------------------------------------
    // Methods

    private showSubscribePullUp(dataItem: any) {
        this.selectedRow = dataItem;
        this.selectedRow.subscriptions.forEach((subscribe: any) => {
           this.$set(subscribe, 'selectedRequestOption', subscribe.subscribeStatus);
           this.$set(subscribe, 'selectedRequested', subscribe.subscribeStatus);
        });
        this.isShowPullup = true;
    }

    private onSelectPage(item: any) {
        this.currentPage = item;
        const offset = (item - 1) * this.contentPerPgae;
        this.$emit('onSelectPage', offset);
    }

    private onSearchItems(searchTerms: any) {
        this.$emit('onSearchItems', searchTerms);
    }

    private onUpdateSubscribe(selectedRow: any, selectedItem: any) {
        const dataTosubscribe = {
            tool_provider_id: this.registryType === 'tool-registry' ? selectedRow.toolDetails.id : selectedItem.id,
            status: selectedItem.selectedRequested,
            tenant_id: selectedItem.tenantId,
        };
        registryAPI.updateSubscribedToolStatus(dataTosubscribe).then((data) => {
            const returnData = data;
            selectedItem.subscribeStatus = selectedItem.selectedRequestOption;
        });
    }

    private onSubscribe(selectedItem: any, popupData?: any) {
        let dataTosubscribe;
        if (popupData) {
            dataTosubscribe = {
                tool_provider_id: this.registryType === 'content-registry'
                    ? selectedItem.toolDetails.id
                    : this.registryType === 'tool-registry'
                    ? selectedItem.toolDetails.id
                    : selectedItem.id,
                status: 'requested',
                tenant_id: this.tenantId,
                rank: popupData.rank,
                use_by: popupData.useBy,
                mandatory_content: popupData.isMandatoryProduct,
            };
        } else {
            dataTosubscribe = {
                tool_provider_id: this.registryType === 'content-registry'
                    ? selectedItem.toolDetails.id
                    : this.registryType === 'tool-registry'
                    ? selectedItem.toolDetails.id
                    : selectedItem.id,
                status: 'requested',
                tenant_id: this.tenantId,
            };
        }
        registryAPI.subscribeSelectedTool(dataTosubscribe).then((data) => {
            this.onSelectPage(this.currentPage);
        });
    }

    private onToogleSubscribe(selectedItem: any, requestedStatus: string, popupData?: any) {
        let dataToUnsubscribe;
        if (popupData) {
            dataToUnsubscribe = {
                tool_provider_id: this.registryType === 'content-registry' ?
                    selectedItem.toolDetails.id : this.registryType === 'tool-registry' ?
                        selectedItem.toolDetails.id : selectedItem.id,
                status: requestedStatus,
                tenant_id: this.tenantId,
                rank: popupData.rank,
                use_by: popupData.useBy,
                mandatory_content: popupData.isMandatoryProduct,
            };
        } else {
            dataToUnsubscribe = {
                tool_provider_id: this.registryType === 'content-registry' ?
                    selectedItem.toolDetails.id : this.registryType === 'tool-registry' ?
                        selectedItem.toolDetails.id : selectedItem.id,
                status: requestedStatus,
                tenant_id: this.tenantId,
            };
        }
        registryAPI.updateSubscribedToolStatus(dataToUnsubscribe).then((data) => {
            this.onSelectPage(this.currentPage);
        });
    }

    private onSearch(searchTerms: string) {
        this.searchTerms = searchTerms;
        this.$emit('onSearchItems', searchTerms);
    }

    private onApplyFilter(filterList: any) {
        this.$emit('onApplyFilter', filterList);
        this.selectedFilter = filterList;
    }

    private handleCancel() {
        this.isShowSubscribePopup = false;
    }

    private handleSubscribe(popupData: any) {
        this.isShowSubscribePopup = false;
        if (this.pendingAction.type === 'subscribe') {
            this.onSubscribe(this.pendingAction.item, popupData);
        } else if (this.pendingAction.type === 'toggle') {
            this.onToogleSubscribe(this.pendingAction.item, this.pendingAction.requestedStatus, popupData);
        }

        this.pendingAction = null;
    }

    private openPopup(type: 'subscribe' | 'toggle', selectedItem: any, requestedStatus?: any ) {
        if (type === 'subscribe') {
            this.isShowSubscribePopup = true;
            this.pendingAction = { type: 'subscribe', item: selectedItem };
        } else if (type === 'toggle') {
            this.isShowSubscribePopup = true;
            this.pendingAction = { type: 'toggle', item: selectedItem, requestedStatus };
        }
    }

}
